// For Firebase JS SDK v7.20.0 and later, measurementId is optional
//NOTE: Don't check in the firebaseConfig into the source repo. Always check-in as empty
//Use the respective Firebase instance config only for your DEV activity only
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig =  { apiKey: 'AIzaSyB-9EJoTp3J6-Jos-p4Sn4LIv5X8Qx2YBc', authDomain: 'dtrk-prinauto-p.firebaseapp.com', databaseURL: 'https://dtrk-prinauto-p-default-rtdb.firebaseio.com', projectId: 'dtrk-prinauto-p', storageBucket: 'dtrk-prinauto-p.appspot.com', messagingSenderId: '950396712934', appId: '1:950396712934:web:e8034b64adf570b4968827', measurementId: '', site: 'prinauto-dtrk' };
const TENANT_ID = 'YSE3YqN93ybLGckus9Odq7XN00i1'
const FIRESTORE_HOSTED_REGION = "us-central1"
const EXPORTCSV = 'exportConfiguration';
const IMPORT_AP_METHOD = 'importAPs'
const IMPORT_DEVICES_METHOD = 'importDevices'
const SAVE_APP_SETTINGS = 'saveAppSettings'
const SAVE_APP_CONFIGURATION = 'saveAppConfiguration'
const RECOM_DECOM = 'recomOrDecomDevice_v2';
const GET_APP_SETTINGS = 'getAppSettings'
const SAVE_SSO_SETTINGS = 'saveSSOSettings'
const MAP_DTRK_TO_SSO_ROLES = 'mapdtrkToSSORoles'
const GET_SSO_SETTINGS = 'getSSOSettings'
const TEST_SSO_SETTINGS = 'ssoConfigTest'
const SAVE_APP_SETTINGS_COMPATIBILITY_VERSION = 'saveAppSettingsCompatibilityVersion'
const GET_APP_CONFIG = 'getAppConfigAtPostDeploy'
const DELETE_USER = 'deleteUser'
const RESET_PASSWORD = 'resetPassword_v2'
const GET_FIREASE_TOKEN_FROM_SSO = 'getFirebaseTokenFromSSO'
const GET_SSO_USER_INFO = 'getSSOUserInfo'
const GET_SERVER_VERSION = 'getServerCFVersion'
const FETCH_LICENSE_SUMMARY = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/fetchLicenseSummary"
const FLEXERA_REFRESH_URL = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/flexeraLicensesRefresh"
const EXPORT_ANALYTIC_DATA_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/analyticsExportCsvDataToGcsBucket"
const UPLOAD_ANALYTIC_DATA_ZIP_FILE_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/analyticsUploadZipFileToGcsBucket"
const CUSTOM_BUCKET_URL = "gs://" + firebaseConfig.projectId + ".appspot.com/"
const BASE_URL = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/";
const SITE_URL = "https://" + firebaseConfig.site + ".web.app";
const WEB_REDIRECT_URI = SITE_URL + '/login';
const ANDROID_REDIRECT_URI = "com.zebra.mdna.devicetrackercloud:/devicecheckout";
const ELS_REDIRECT_URI = "com.zebra.mdna.els:/loginComplete"
const DOG_FOOD_DOC = "https://zebra-beta.github.io/devicetracker/dogfood/guide/about/"
const GA_DOC = "https://techdocs.zebra.com/devicetracker/"
const EXPORT_ANALYTIC_EVENT_SUMMARY_DATA_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/eventsSummaryExport"
const EXPORT_ANALYTIC_CHECKOUT_SUMMARY_DATA_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/checkOutSummaryExport"
const EXPORT_ANALYTIC_DEVICE_UTILIZATION_TIME_DATA_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/deviceUtilizationTimeExport"
const EXPORT_ANALYTIC_DEVICE_UTILIZATION_LOG_DATA_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/deviceUtilizationLogsExport"
const EXPORT_DEVICES_SNAPSHOT_DATA_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/devicesSnapshotExport"
const EXPORT_EVENT_SUMMARY_COUNT_SNAPSHOT_DATA_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/summaryCountsSnapshotExport"
const UPLOAD_ANALYTIC_EVENT_SUMMARY_DATA_ZIP_FILE_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/eventSummaryZipAndUpload"
const UPLOAD_ANALYTIC_DEVICE_CHECKOUT_SUMMARY_DATA_ZIP_FILE_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/checkOutSummaryZipAndUpload"
const UPLOAD_ANALYTIC_DEVICE_UTILIZATION_TIME_DATA_ZIP_FILE_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/deviceUtilizationTimeZipAndUpload"
const UPLOAD_ANALYTIC_DEVICE_UTILIZATION_LOGS_DATA_ZIP_FILE_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/deviceUtilizationLogsZipAndUpload"
const UPLOAD_DEVICES_SNAPSHOT_DATA_ZIP_FILE_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/devicesSnapshotZipAndUpload"
const UPLOAD_EVENT_SUMMARY_COUNT_SNAPSHOT_DATA_ZIP_FILE_TO_GCS_BUCKET = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/summaryCountsSnapshotZipAndUpload"
const EXPORT_ANALYTIC_EVENT_SUMMARY_DETAIL = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/eventsSummaryDetailByCategoryExport"
const EXPORT_ANALYTIC_EVENT_SUMMARY_DETAIL_ZIP_FILE = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/eventsSummaryDetailByCategoryZipAndUpload"
const GET_DEVICE_UTILIZATION_DATA = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/getDeviceUtilizationData"
const GET_SITE_EVENT_DATA = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/getSiteEventData"
const GET_SNAPPSHOT_DATA = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/getSnapshotData"
const GET_CHECKOUT_LOG_DATA = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/getCheckoutLogData"
const GET_DEVICE_CHECKOUT_COUNT_DATA = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/getDeviceCheckoutCountData"
const GET_EVENT_COUNTS = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/getEventCounts"
const ERROR_CODES = {
    USER_NOT_FOUND: "auth/user-not-found",
    WRONG_PASSWORD: "auth/wrong-password",
    NETWORK_FAILED: "auth/network-request-failed"
}

const USER_NOT_REGISTERED = 'The email you entered is not registered. Please contact your administrator for further assistance.'
const USER_INVALID_CREDENTIALS = 'Login failed: Invalid password.'
const USER_LOGIN_FAILED = 'Login failed: Internal error'
const REVOKE_TOKEN_ACCESS = 'revokeTokenAccess'
const UPDATE_MANAGER = "updateManager"
const SSO_SESSION_LOGOUT = 'ssoLogout'
const REVOKE_TOKEN_WITH_SSO_SERVER = 'revokeTokenWithSSOServer'
const CREATE_USER_METHOD = {
    'admin': 'createAdmin',
    'manager': 'createManager'
}

const ENABLE_DEBUG = false
const ENABLE_DOGFOOD = false
const ENABLE_MAX_CHECKOUT_TIME = true
const ENABLE_CHECKIN_CHECKOUT = true
const ENABLE_GLOBAL_MANAGER = false
const ENABLE_BT_SCANNER_TRACKING = true
const EMAIL_RULES = "A valid email is required. The general rules are " +
    "dot is allowed only in between combinations, " +
    "hyphen cannot be used at the start of end of domain and subdomains and id sections, " +
    "Following symbols not allowed () [] \\ ; : \" < > and space"
//NOTE: Regex Validation leads to Regex DOS security attack, so replaced this with valid-url middleware validation
//const URL_REGEX = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
const ROW_ITEMS_PER_PAGE = 10;
const ERROR_FETCH_SSO_TOKEN = "Error in fetching SSO Token";

// Replace Web Socket
const USE_WEB_SOCKET = false;
const GET_DEVICE_COUNT = "https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/getDeviceSummaryCount"
const GET_PRODUCTIVITY_DATA ="https://" + FIRESTORE_HOSTED_REGION + "-" + firebaseConfig.projectId + ".cloudfunctions.net/getRoIData"
module.exports = {
    FIRESTORE_HOSTED_REGION,
    ENABLE_DEBUG,
    ENABLE_DOGFOOD,
    ENABLE_MAX_CHECKOUT_TIME,
    IMPORT_AP_METHOD,
    CREATE_USER_METHOD,
    IMPORT_DEVICES_METHOD,
    SAVE_APP_SETTINGS,
    RECOM_DECOM,
    GET_APP_SETTINGS,
    SAVE_SSO_SETTINGS,
    MAP_DTRK_TO_SSO_ROLES,
    GET_SSO_SETTINGS,
    TEST_SSO_SETTINGS,
    SAVE_APP_SETTINGS_COMPATIBILITY_VERSION,
    GET_APP_CONFIG,
    GET_SERVER_VERSION,
    firebaseConfig,
    DELETE_USER,
    USER_NOT_REGISTERED,
    USER_INVALID_CREDENTIALS,
    ERROR_CODES,
    USER_LOGIN_FAILED,
    RESET_PASSWORD,
    ENABLE_CHECKIN_CHECKOUT,
    ENABLE_GLOBAL_MANAGER,
    ENABLE_BT_SCANNER_TRACKING,
    REVOKE_TOKEN_ACCESS,
    SSO_SESSION_LOGOUT,
    FETCH_LICENSE_SUMMARY,
    FLEXERA_REFRESH_URL,
    EMAIL_RULES,
    CUSTOM_BUCKET_URL,
    EXPORT_ANALYTIC_DATA_TO_GCS_BUCKET,
    UPLOAD_ANALYTIC_DATA_ZIP_FILE_TO_GCS_BUCKET,
    BASE_URL,
    SITE_URL,
    WEB_REDIRECT_URI,
    ANDROID_REDIRECT_URI,
    ELS_REDIRECT_URI,
    GET_FIREASE_TOKEN_FROM_SSO,
    ROW_ITEMS_PER_PAGE,
    UPDATE_MANAGER,
    DOG_FOOD_DOC,
    GA_DOC,
    TENANT_ID,
    EXPORT_ANALYTIC_EVENT_SUMMARY_DATA_TO_GCS_BUCKET,
    EXPORT_ANALYTIC_CHECKOUT_SUMMARY_DATA_TO_GCS_BUCKET,
    EXPORT_ANALYTIC_DEVICE_UTILIZATION_TIME_DATA_TO_GCS_BUCKET,
    EXPORT_ANALYTIC_DEVICE_UTILIZATION_LOG_DATA_TO_GCS_BUCKET,
    UPLOAD_ANALYTIC_EVENT_SUMMARY_DATA_ZIP_FILE_TO_GCS_BUCKET,
    UPLOAD_ANALYTIC_DEVICE_CHECKOUT_SUMMARY_DATA_ZIP_FILE_TO_GCS_BUCKET,
    UPLOAD_ANALYTIC_DEVICE_UTILIZATION_TIME_DATA_ZIP_FILE_TO_GCS_BUCKET,
    UPLOAD_ANALYTIC_DEVICE_UTILIZATION_LOGS_DATA_ZIP_FILE_TO_GCS_BUCKET,
    EXPORT_DEVICES_SNAPSHOT_DATA_TO_GCS_BUCKET,
    EXPORT_EVENT_SUMMARY_COUNT_SNAPSHOT_DATA_TO_GCS_BUCKET,
    UPLOAD_DEVICES_SNAPSHOT_DATA_ZIP_FILE_TO_GCS_BUCKET,
    UPLOAD_EVENT_SUMMARY_COUNT_SNAPSHOT_DATA_ZIP_FILE_TO_GCS_BUCKET,
    EXPORT_ANALYTIC_EVENT_SUMMARY_DETAIL,
    EXPORT_ANALYTIC_EVENT_SUMMARY_DETAIL_ZIP_FILE,
    GET_DEVICE_UTILIZATION_DATA,
    GET_SITE_EVENT_DATA,
    GET_SNAPPSHOT_DATA,
    GET_CHECKOUT_LOG_DATA,
    GET_DEVICE_CHECKOUT_COUNT_DATA,
    GET_EVENT_COUNTS,
    EXPORTCSV,
    ERROR_FETCH_SSO_TOKEN,
    REVOKE_TOKEN_WITH_SSO_SERVER,
    GET_SSO_USER_INFO,
    SAVE_APP_CONFIGURATION,
    USE_WEB_SOCKET,
    GET_DEVICE_COUNT,
    GET_PRODUCTIVITY_DATA,
}